export default "__VITE_ASSET__DlTitpOy__"